export enum BeneficiaryQueryKeysEnum {
  BENEFICIARY_SERVICES_LIST_STATE = 'BeneficiaryServicesListState',
  BENEFICIARY_SERVICES_REDIRECT_STATE = 'BeneficiaryServicesRedirectState',
}
